import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "w-full h-auto" };
import { useHomeFilterStore } from './homeFilterStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-other',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, "this is other"));
        };
    }
});
